/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  //  useNavigate,
  useParams,
} from 'react-router-dom';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import NoSearchResults from '../../one-way/NoSearchResults';
// import AppLink from '../../../shared/components/app-link/AppLink';
import './BusBookingDetails.scss';
import {
  GENDER_OPTIONS_DICT,
  // NAVIGATION_ROUTES,
  STATUS_OPTIONS_DICT,
} from '../../../shared/constants/Constants';
import {
  getBusBookingCancellationDetailsApi,
  getBusBookingDetailsApi,
} from '../../../api/busApi';
import BookingDetails from './BookingDetails';

function BusBookingCancellationDetails() {
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [bookingDetails, setBookingDetails] = useState({});
  const [cancellationDetails, setCancellationDetails] = useState({});
  const [isSearchDone, setSearchDone] = useState(false);
  // const navigate = useNavigate();

  const getBusBookingDetails = async (txid) => {
    const response = await getBusBookingDetailsApi(txid);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.BusInvoice || {};
      setBookingDetails(data);
      setSearchDone(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Bookings Details',
        description: response?.Root?.Message,
      });
    }
  };

  const getBusCancellationDetails = async () => {
    setLoading(true);
    const response = await getBusBookingCancellationDetailsApi(transactionId);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.BusCancellation || {};
      if (data.BusPassengers && data.BusPassengers.BusPassenger) {
        data.BusPassengers.BusPassenger = Array.isArray(
          data.BusPassengers.BusPassenger,
        )
          ? data.BusPassengers.BusPassenger
          : [data.BusPassengers.BusPassenger];
      } else {
        data.BusPassengers = { BusPassenger: [] };
        data.BusPassengers.BusPassenger = [
          {
            Title: data.PaxSalutation,
            FirstName: data.PaxFirstName,
            LastName: data.PaxLastName,
            SeatNumber: data.SeatsSelected,
            Age: data.PaxAge,
            Gender: data.PaxGender,
            Status: data.TicketStatus,
          },
        ];
      }
      setCancellationDetails(data);
      getBusBookingDetails(data.ReferenceTxid);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Cancellation Details',
        description: response?.Root?.Message,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getBusCancellationDetails();
  }, []);

  // const bookingVoucher = () => {};

  const getFullName = (item) => {
    let name = '';
    if (item.Title) name += item.Title;
    if (item.FirstName) name += ` ${item.FirstName}`;
    if (item.LastName) name += ` ${item.LastName}`;
    return name;
  };

  return (
    <section className="pt-3">
      <section className="app-container">
        <section className="view-booking-details-page">
          <AppLoading isLoading={isLoading} />
          {alert && (
            <AppAlert
              showIcon
              variant={alert.variant}
              title={alert.title}
              onHide={() => setAlert(undefined)}
              description={alert.description}
            />
          )}
          {isSearchDone && (
            <>
              <div className="view-booking-details-page__header">
                <span>Bus Cancellation Details</span>
                <span className="primary-color">{transactionId}</span>
              </div>
              <div className="separator" />
              {Object.keys(bookingDetails).length > 0 ? (
                <>
                  <BookingDetails bookingDetails={bookingDetails} />
                  <div className="separator" />
                  <div className="view-booking-details-page_passenger-details">
                    <Row className="spacing-16">
                      <Col lg={12}>
                        <Row className="spacing-16">
                          <Col lg={3} md={3} sm={3}>
                            <span className="passenger-label">
                              Passenger Name
                            </span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Seat Number</span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Gender</span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Age</span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Status</span>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12}>
                        <Row className="spacing-16">
                          {cancellationDetails.BusPassengers.BusPassenger.map(
                            (d, index) => (
                              <Col lg={12} key={index}>
                                <Row className="spacing-16">
                                  <Col lg={3} md={3} sm={3}>
                                    <span className="passenger-value">
                                      {getFullName(d)}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value">
                                      {d.SeatNumber || '-'}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value">
                                      {d.Gender
                                        ? GENDER_OPTIONS_DICT[
                                            d.Gender.toLowerCase()
                                          ]
                                        : '-'}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value">
                                      {d.Age || '-'}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value green-color">
                                      {d.Status
                                        ? STATUS_OPTIONS_DICT[
                                            d.Status.toLowerCase()
                                          ]
                                        : '-'}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            ),
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="separator" />
                  <div className="view-booking-details-page_passenger-details">
                    <Row className="spacing-16">
                      <Col lg={2} md={2} sm={3}>
                        <div className="d-flex flex-column">
                          <span className="passenger-label">
                            Cancellation Amount
                          </span>
                          <span className="passenger-value">
                            {cancellationDetails.CanxChargeOta || 0}
                          </span>
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={3}>
                        <div className="d-flex flex-column">
                          <span className="passenger-label">
                            Operator Cancellation Amount
                          </span>
                          <span className="passenger-value">
                            {cancellationDetails.OperatorCanxCharge || '-'}
                          </span>
                        </div>
                      </Col>
                      <Col lg={2} md={2} sm={3}>
                        <div className="d-flex flex-column">
                          <span className="passenger-label">Refund Amount</span>
                          <span className="passenger-value">
                            {cancellationDetails.RefundAmount || '-'}
                          </span>
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={3}>
                        <div className="d-flex flex-column">
                          <span className="passenger-label">
                            Operator Refund Amount
                          </span>
                          <span className="passenger-value">
                            {cancellationDetails.RefundAmountOperator || '-'}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {/* <div className="separator" />
                  <div className="view-booking-details-page__actions">
                    <Row className="spacing-16">
                      <Col lg={2} md={4} sm={6}>
                        <AppLink
                          linkText="Booking Voucher"
                          onClick={bookingVoucher}
                          variant="primary"
                          className="fw-600"
                        />
                      </Col>
                    </Row>
                  </div> */}
                </>
              ) : (
                <NoSearchResults />
              )}
            </>
          )}
        </section>
      </section>
    </section>
  );
}

BusBookingCancellationDetails.defaultProps = {};

BusBookingCancellationDetails.propTypes = {};

export default BusBookingCancellationDetails;
